// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapButtons{display:flex;flex-direction:column;position:fixed;bottom:47px;left:436px;justify-content:space-between;gap:8px;transition:transform .3s cubic-bezier(0.645, 0.045, 0.355, 1)}.mapButtons.MOBILE{left:10px}.mapButtons>div{height:42px}body.sidebar-collapsed .mapButtons:not(.MOBILE){transform:translateX(-404px)}.mapboxgl-ctrl-attrib{margin-left:30px !important}", ""]);
// Exports
module.exports = exports;
